import React, { useEffect, useState } from "react";
import TextAreaComponents from "../../../../components/TextAreaComponents/TextAreaComponents.tsx";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs, { Dayjs } from "dayjs";
import jwt_decode from "jwt-decode";

function Personels(props) {
  const [FirstName, setFirstName] = useState(false);
  const [Lastname, setLastname] = useState(false);
  const [HomeAddress, setHomeAddress] = useState(false);
  const [ZipCode, setZipCode] = useState(false);
  const [City, setCity] = useState(false);
  const [Country, setCountry] = useState(false);
  const [PhoneNumber, setPhoneNumber] = useState(false);
  const [Email, setEmail] = useState(false);
  const [ConfirmEmail, setConfirmEmail] = useState(false);
  const [Passport, setPassport] = useState(false);

  const [tokenData, setTokenData] = useState({});
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);
        console.log(decodedData);
        setTokenData(decodedData);
      } catch (error) {}
    }
  };

  const [obj, setObj] = React.useState({
    ID: "Director",
    KycCompanyDetailsId: "companyDetails",
    PersonelsType: "Director",
    FirstName: "",
    LastName: "",
    DOB: new Date(),
    HomeAddress: "",
    ZipCode: "",
    City: "",
    Country: "",
    PhoneNumber: "",
    EmailAddress: "",
    ConfirmEmailAddress: "",
    PassportOrIdNumber: "",
    Rank: 1,
    OwnerShipPercentage: 0,
    CreationId: "creationId",
  });

  const sendDataToParent = () => {
    props.val(obj);
  };

  const firstnameFieldValue = (props) => {
    console.log(props);
    obj.FirstName = props;
    setFirstName(false);
    sendDataToParent();
  };
  const lastnameFieldValue = (props) => {
    console.log(props);
    obj.LastName = props;
    setLastname(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    sendDataToParent();
  };
  const [value, setValue] = React.useState<Dayjs | null>(dayjs("2022-04-17"));
  const DOBFieldValue = (props) => {
    var month = parseInt(props.$M + 1);
    var day = props.$y + "-" + month + "-" + props.$D;
    var mydate = new Date(day);

    console.log(mydate);
    console.log(props);
    obj.DOB = mydate;
    sendDataToParent();
  };
  const homeAddressFieldValue = (props) => {
    console.log(props);
    obj.HomeAddress = props;
    setHomeAddress(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    sendDataToParent();
  };
  const postalCodeFieldValue = (props) => {
    console.log(props);
    obj.ZipCode = props;
    setZipCode(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    sendDataToParent();
  };
  const cityFieldValue = (props) => {
    console.log(props);
    obj.City = props;
    setCity(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    sendDataToParent();
  };
  const CountryFieldValue = (props) => {
    console.log(props);
    obj.Country = props;
    setCountry(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    if (obj.City.trim() === "") {
      setCity(true);
    }
    sendDataToParent();
  };
  const PhoneNumberFieldValue = (props) => {
    console.log(props);
    obj.PhoneNumber = props;
    setPhoneNumber(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    if (obj.City.trim() === "") {
      setCity(true);
    }
    if (obj.Country.trim() === "") {
      setCountry(true);
    }
    sendDataToParent();
  };

  const [isValidEmail, setIsValidEmail] = useState(false);
  const validateEmail = (props) => {
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    setIsValidEmail(!emailPattern.test(props));
  };
  const EmailAddressFieldValue = (props) => {
    console.log(props);
    obj.EmailAddress = props;
    setEmail(false);
    validateEmail(obj.EmailAddress);
    console.log(isValidEmail);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    if (obj.City.trim() === "") {
      setCity(true);
    }
    if (obj.Country.trim() === "") {
      setCountry(true);
    }
    if (obj.PhoneNumber.trim() === "") {
      setPhoneNumber(true);
    }
    sendDataToParent();
  };

  const [EmailMatching, setEmailMatching] = useState(false);
  const ConfirmEmailAddressFieldValue = (props) => {
    obj.ConfirmEmailAddress = props;
    if (obj.ConfirmEmailAddress != obj.EmailAddress) {
      setEmailMatching(true);
    } else {
      setEmailMatching(false);
    }
    setConfirmEmail(false);
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    if (obj.City.trim() === "") {
      setCity(true);
    }
    if (obj.Country.trim() === "") {
      setCountry(true);
    }
    if (obj.PhoneNumber.trim() === "") {
      setPhoneNumber(true);
    }
    if (obj.EmailAddress.trim() === "") {
      setEmail(true);
    }
    sendDataToParent();
  };
  const PassportFieldValue = (props) => {
    console.log(props);
    obj.PassportOrIdNumber = props;
    if (obj.FirstName.trim() === "") {
      setFirstName(true);
    }
    if (obj.LastName.trim() === "") {
      setLastname(true);
    }
    if (obj.HomeAddress.trim() === "") {
      setHomeAddress(true);
    }
    if (obj.ZipCode.trim() === "") {
      setZipCode(true);
    }
    if (obj.City.trim() === "") {
      setCity(true);
    }
    if (obj.Country.trim() === "") {
      setCountry(true);
    }
    if (obj.PhoneNumber.trim() === "") {
      setPhoneNumber(true);
    }
    if (obj.EmailAddress.trim() === "") {
      setEmail(true);
    }
    if (obj.ConfirmEmailAddress.trim() === "") {
      setConfirmEmail(true);
    }
    sendDataToParent();
  };

  return (
    <div>
      <div className="managementCards">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"First name"}
              value={firstnameFieldValue}
              id={6}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Last name"}
              value={lastnameFieldValue}
              error={Lastname}
              id={6}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            {/* <TextAreaComponents label={'Date of birth'} value={DOBFieldValue} id={6}></TextAreaComponents> */}
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              sx={{ width: "100%", padding: "0" }}
            >
              <DemoContainer
                components={["DatePicker"]}
                sx={{ width: "100%", padding: "0" }}
              >
                <DatePicker
                  label="Date of birth"
                  sx={{ width: "100%", padding: "0" }}
                  onChange={(newValue) => DOBFieldValue(newValue)}
                  className="custom-textField custom-DateField"
                  maxDate={dayjs(new Date())}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Home address"}
              value={homeAddressFieldValue}
              error={HomeAddress}
              id={6}
            ></TextAreaComponents>
          </Grid>

          <Grid item xs={6}>
            <TextAreaComponents
              label={"Postal code/Zip code "}
              value={postalCodeFieldValue}
              error={ZipCode}
              id={9}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"City"}
              value={cityFieldValue}
              error={City}
              id={6}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Country"}
              value={CountryFieldValue}
              error={Country}
              id={6}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Phone number"}
              value={PhoneNumberFieldValue}
              id={12}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Email Address"}
              value={EmailAddressFieldValue}
              isValid={isValidEmail}
              error={Email}
              id={6}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Confirm email Address"}
              value={ConfirmEmailAddressFieldValue}
              isMatched={EmailMatching}
              error={ConfirmEmail}
              id={14}
            ></TextAreaComponents>
          </Grid>
          <Grid item xs={6}>
            <TextAreaComponents
              label={"Passport / ID number"}
              value={PassportFieldValue}
              id={9}
            ></TextAreaComponents>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Personels;
